import type { ReactNode } from "react";

import { NavLeft, NavRight } from "./Nav";

export const Header = ({
  logo,
  leftLinks,
  rightLinks,
  popup,

  className,
}: {
  logo: ReactNode;
  leftLinks: ReactNode;
  rightLinks: ReactNode;
  popup: ReactNode;

  className?: string;
}) => {
  return (
    <header className={className}>
      <nav className="container m-auto flex flex-row items-center justify-between px-8 py-1 duration-1000 animate-in fade-in">
        <NavLeft logo={logo}>{leftLinks}</NavLeft>
        <NavRight popup={popup}>{rightLinks}</NavRight>
      </nav>
    </header>
  );
};
